/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { moduleToggleOverrideStates } from './module-toggle-overrides.route';

@NgModule({
    declarations: [],
    imports: [CommonModule, UIRouterModule.forChild({ states: moduleToggleOverrideStates })],
})
export class ModuleToggleOverridesModule {}
